export const WHATSAPP_GROUP_URL = 'https://chat.whatsapp.com/BkbBpFfyeu1IG8q1PxeRlV';
